const initialState = {
    facilityPermissions:{},
    facilityLists: [],
    facilityStatus: [],
    changedFacilityStatus : [],
    loadingFacility: false,
    errorsFacility: {}
}

const  facilityReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_FACILITY_LIST_PENDING":
        case "ADD_FACILITY_PENDING":
        case "UPDATE_FACILITY_PENDING":
        case "UPDATE_FACILITY_STATUS_PENDING":
        case "DELETE_FACILITY_PENDING":
        case "GET_FACILITY_LIST_BY_ID_PENDING":
            return { ...state, loadingFacility: true };

        case "GET_FACILITY_LIST_FULFILLED":
            return {
                ...state,
                loadingFacility: false,
                facilityLists: action.payload,
                facilityCount: action.facilityCount,
                facilityPermissions:action.permissions,
            };

        case "ADD_FACILITY_FULFILLED":
            return {
                ...state,
                loadingFacility: false,
                changedFacilityStatus: action.payload,
            };

        case "UPDATE_FACILITY_FULFILLED":
            return {
                ...state,
                loadingFacility: false,
                changedFacilityStatus: action.payload,
            };

        case "UPDATE_FACILITY_STATUS_FULFILLED":
            return {
                ...state,
                loadingFacility: false,
                changedFacilityStatus: action.payload,
            };

        case "GET_FACILITY_LIST_BY_ID_FULFILLED":
            return {
                ...state,
                loadingFacility: false,
                facilityLists: action.payload
            };

        case "DELETE_FACILITY_FULFILLED":
            return {
                ...state,
                loadingFacility: false,
                changedFacilityStatus: action.payload
            };

        case "RESET_DELETE_FACILITY_STATUS":
            return {
                ...state,
                loadingFacility: false,
                changedFacilityStatus: [],
                errorsFacility:{}
            };

        case "GET_FACILITY_LIST_REJECTED":
        case "ADD_FACILITY_REJECTED":
        case "UPDATE_FACILITY_REJECTED":
        case "UPDATE_FACILITY_STATUS_REJECTED":
        case "DELETE_FACILITY_REJECTED":
        case "GET_FACILITY_LIST_BY_ID_REJECTED":
            return {
                ...state,
                loadingFacility: false,
                errorsFacility: action.payload
            };

        default:
            return state;
    }
}

export default facilityReducer;